export default function SubSection({ children, final }) {
  return <div className={`SubSection ${final != null ? 'final' : ''}`}>{children}</div>;
}
